import moment from 'moment';
import QRCode from 'qrcode';

export const ticketSet = async (items, client, customer) => {
    // Generate QR Code image
    const qrCodes = [];
    const generateQR = async (tickets) => {
        for (const ticket of tickets) {
            try {
                let code = await QRCode.toDataURL(`${ticket.id}`);

                // If Streaming event, QR code should be
                if (ticket.event.event_type === 'Live Stream' || ticket.event.event_type === 'Scheduled Content' || ticket.event.event_type === 'Video On Demand') {
                    code = await QRCode.toDataURL(`https://www.showtix4u.com/stream/${ticket.activation_code}`);
                }
                qrCodes.push(code.split(',')[1]);
            } catch (err) {
                console.error(err)
            }
        }
    }

    await generateQR(items);

    const labelRecords = items.map((item, i) => {
        let section;
        let row;
        let seat;
        let explanation = '';
        let explanation2 = '';
        let explanation3 = '';
        let explanationStub = '';
        let explanationStub2 = '';

        let dateShort = moment(item.event_date.event_datetime_local).format('ddd, MMM Do YYYY @ h:mm a');;
        let dateLong = moment(item.event_date.event_datetime_local).format('LLLL').toString();
        if (item.event_date.event_datetime_local) {
            dateShort = moment(item.event_date.event_datetime_local.substring(0, 19)).format('ddd, MMM Do YYYY @ h:mm a');
            dateLong = moment(item.event_date.event_datetime_local.substring(0, 19)).format('LLLL').toString();
        }

        let SectionRowSeat = item.full_seat_name.split(':');
        if (item.venue.venue_type === 'general-admission') {
            section = ``;
            row = `General Admission: `;
            seat = `${SectionRowSeat[2]}`;
        } else {
            section = `Section: ${SectionRowSeat[0]}`;
            row = `Row: ${SectionRowSeat[1]}`;
            seat = `Seat: ${SectionRowSeat[2]}`;
        }

        let venueName = item.venue.name;
        let venueAddress = item.venue.address;

        const price = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(item.price);


        if (item.event.event_type !== 'Event') {
            dateShort = '';
            dateLong = '';
            venueName = '';
            venueAddress = '';
        }

        if (item.event.event_type === 'Live Stream' || item.event.event_type === 'Video On Demand' || item.event.event_type === 'Scheduled Content') {
            dateShort = moment(item.event_date.event_datetime_local).format('ddd, MMM Do YYYY @ h:mm a');;
            dateLong = moment(item.event_date.event_datetime_local).format('LLLL').toString();
            if (item.event_date.event_datetime_local) {
                dateShort = moment(item.event_date.event_datetime_local.substring(0, 19)).format('ddd, MMM Do YYYY @ h:mm a');
                dateLong = moment(item.event_date.event_datetime_local.substring(0, 19)).format('LLLL').toString();
            }
            venueName = '';
            venueAddress = '';
            section = '';
            row = '';
            explanation = 'You can access the Live Stream/Video using any of these options:'
            explanation2 = '1. Point your mobile camera at the QR code and click on the notifications that appears. '
            explanation3 = `2. Go to www.ShowTix4U.com/stream and enter the code: ${item.activation_code}`;
            seat = '';
            explanationStub = 'www.ShowTix4U.com/stream';
            explanationStub2 = `Access Code: ${item.activation_code}`;
        }

        // Do not show date for VOD
        if (item.event.event_type === 'Video On Demand') {
            dateShort = '';
            dateLong = '';
        }

        return (
            `<LabelRecord>
                <ObjectData Name="STUBSECTION">${section}</ObjectData>
                <ObjectData Name="STUBROWSEAT">${row} ${seat}</ObjectData>
                <ObjectData Name="STUBEXPLANATION">${explanationStub}</ObjectData>
                <ObjectData Name="STUBEXPLANATION2">${explanationStub2}</ObjectData>
                <ObjectData Name="STUBDATETIME">${dateShort}</ObjectData>
                <ObjectData Name="STUBORDERINFO">${price}</ObjectData>
                <ObjectData Name="CLIENTNAME">${client.client_name}</ObjectData>
                <ObjectData Name="EVENTNAME1">${item.event.name}</ObjectData>
                <ObjectData Name="EVENTDATETIME">${dateLong}</ObjectData>
                <ObjectData Name="VENUENAME">${venueName}</ObjectData>
                <ObjectData Name="VENUEADDRESS">${venueAddress}</ObjectData>
                <ObjectData Name="EVENTSECTION">${section}</ObjectData>
                <ObjectData Name="EVENTEXPLANATION">${explanation}</ObjectData>
                <ObjectData Name="EVENTEXPLANATION2">${explanation2}</ObjectData>
                <ObjectData Name="EVENTEXPLANATION3">${explanation3}</ObjectData>
                <ObjectData Name="EVENTROWSEAT">${row} ${seat}</ObjectData>
                <ObjectData Name="PRICE">${price}</ObjectData>
                <ObjectData Name="EVENTORDERINFO">Order: ${item.transaction_id} - ${customer.first_name} ${customer.last_name}</ObjectData>
                <ObjectData Name="BARCODE">${qrCodes[i]}</ObjectData>
            </LabelRecord>`
        );
    }).join('');

    return (
        `<LabelSet>${labelRecords}</LabelSet>`
    )
}



// WEBPACK FOOTER //
// ./src/lib/labels/ShowTix4UTicketSet.js